module.exports = __webpack_public_path__ + "img/golya80.20a83158.jpg";